/** Only standalone meeting entry may bypass the default dashboard after sign-in. */
export function safeLoginReturn(value: string | null | undefined): string {
  return value && value.length === 51 && /^\/meeting-entry\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) ? value : '/';
}
export function loginCallbackUrl(value: string | null | undefined, origin: string): string {
  return new URL(safeLoginReturn(value), origin).toString();
}
